<template>
    <pop :showMask="true" :allowClose="false">
        <div :class="`comp-gallery-pop-layout1 pc ${theme}`" ref="galleryPopRef">
            <div class="com-gallery-pop_inner">
                <!-- tab -->
                <div class="inner-header">
                    <div class="inner-tab">
                        <template v-for="(item, index) in tabs">
                            <p
                                v-if="showCurrentTab(item)"
                                :key="'tab-' + item.name"
                                :class="{ active: item.value === selectedTab }"
                                @click="handleChangeTabs(item, index)"
                            >
                                {{ item.name }}
                            </p>
                        </template>
                    </div>
                    <!-- status -->

                    <div class="inner-status">
                        <div
                            v-if="!sold"
                            class="pop-icons save"
                            @click="onFavoriteClick"
                        >
                            <i class="iconfont" :class="hasFavor ? 'icon-favorite_02' : 'icon-favorite_01'"></i>
                        </div>
                        <div class="pop-icons share">
                            <i
                                class="iconfont icon-share2"
                            ></i>
                            <share-popper
                                class="popper"
                                :shares="shares"
                                :theme="theme"
                                :listingId="info.id"
                            />
                        </div>
                        <div class="pop-icons tour" @click="schedulePop" v-if="!sold">
                            {{ $t('md-detail-info.requestShowing') }}
                        </div>
                        <div class="pop-icons request" v-if="sold">
                            <span @click="request">{{
                                $t('md-detail-info.requestAFreeAnalysis')
                            }}</span>
                        </div>
                        <div class="pop-icons">
                            <i
                                class="iconfont icon-close-light"
                                @click="closeInnerPop"
                            ></i>
                        </div>
                    </div>
                </div>

                <!-- content -->
                <div class="inner-content">
                    <div class="img-tabs" v-if="selectedTab == 'imgs'">
                        <template v-for="(item, index) in getSourceList">
                            <template v-if="['img'].includes(item.type)">
                                <img-box
                                    :class="[
                                        {
                                            active:
                                                currentMediaTabIndex == index
                                        }
                                    ]"
                                    :src="item.preview"
                                    :key="index"
                                    :lazy="false"
                                    alt
                                    @click="streamToInner(item, index)"
                                />
                            </template>
                        </template>
                    </div>
                    <div class="video-container" v-else>
                        <div
                            v-for="(item, i) in getSourceList"
                            :key="item.type + i"
                            class="video-content"
                        >
                            <!--  can be used video use video -->
                            <video
                                v-if="
                                    canPlayWithVideo(item.url)
                                "
                                :src="item.url"
                                controls="controls"
                            ></video>
                            <iframe
                                v-else
                                :style="iframeStyle"
                                frameborder="no"
                                :src="formatUrl(item.url)"
                                allow="autoplay; fullscreen"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </pop>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
// import mySlider from '@/components/slider';
import util from '@/common/util';
import SharePopper from './share-popper.vue';
import PreviewImagePop from "./previewImagePop.vue"
import popMgr from '@/components/global/popMgr';
// import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import signLog from '@/components/sign-log';
import API from './api.js';
function getMatterPort(links = [], type = '3d') {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type,
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}
export default {
    emits: ['share'],
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            DEFAULT_IMAGE:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            selectedTab: 'imgs',
            source: {
                imgs: [],
                virtuals: [],
                videos: []
            },
            currentMediaTabIndex: 0,
            scaleValue: 100,
            defaultScaleValue: 100,
            swiper: null
        };
    },
    components: {
        SharePopper
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page || {},
            'siteId': 'siteId'
        }),
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        ...mapState({
            'hasFavor': store => store.hasFavor
        }),
        infoLogo() {
            return this.info?.mlsOrg?.logo;
        },
        companyName() {
            return this.info?.agentOrganizationName;
        },
        listingId() {
            return this.info?.mlsListingId;
        },
        allImgs() {
            return this.source?.imgs?.filter(v => v.type === 'img') || [];
        },
        info() {
            return this.listingDetail.info || {};
        },
        iframeStyle() {
            return 'width: 100%; height: 100%';
        },
        getSourceList() {
            return this.source[this.selectedTab];
        },
        getScaleValue() {
            return this.scaleValue;
        },
        tabs() {
            return [
                { name: this.$t('md-detail-info.photos'), value: 'imgs' },
                {
                    name: this.$t('md-detail-info.virtualTour'),
                    value: 'virtuals'
                },
                { name: this.$t('md-detail-info.videoTour'), value: 'videos' }
            ];
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
    },
    props: {
        onFavoriteClick: {
            type: Function,
            default: () => {}
        },
        shares: {
            type: Object,
            default: () => {}
        },
        listingDetail: {
            type: Object,
            required: true
        },
        sold: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'classic'
        },
        schedulePop: {
            type: Function,
            default: () => {}
        }
    },
    created() {
        this.initGalleryData();
    },
    beforeMount() {
        this.fingerPs = Promise.all([
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/AlloyFinger.js'
            ),
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/transform.js'
            )
        ]);
        // window.addEventListener('keyup', this.onKeyUp, false);
    },
    unmounted() {
        // window.removeEventListener('keyup', this.onKeyUp, false);
    },
    methods: {
        /**
         * type
         * photo -> img
         * virtuals -> 3d,virtualTour
         * videos-> video
         */
        initGalleryData: function() {
            let listingPictures = !this.info.listingPictures
                ? []
                : this.info.listingPictures.split('|').filter(item => !!item);
            this.source.imgs = listingPictures.map(url => {
                return {
                    preview: url,
                    type: 'img',
                    url
                };
            });

            let { link, chimeVideoLink } = this.info;

            let virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];

            let placeImageIndex = 0;
            if (virtualLinks.length > 0) {
                let virtualMatterport = getMatterPort([...virtualLinks], '3d');
                if (virtualMatterport) {
                    this.source.virtuals.push(virtualMatterport);
                } else {
                    this.source.virtuals.push({
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'virtualTour',
                        url: virtualLinks[0]
                    });
                }
            }
            if (videoLinks.length > 0) {
                let videoMatterport = getMatterPort([...videoLinks], '3d');
                if (videoMatterport) {
                    this.source.videos.push(videoMatterport);
                } else {
                    this.source.videos.push({
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'video',
                        url: videoLinks[0]
                    });
                }
            }

            if (this.source.imgs.length === 0) {
                this.source.imgs.push({
                    preview: this.DEFAULT_IMAGE,
                    type: 'img',
                    url: this.DEFAULT_IMAGE
                });
            }
        },
        showCurrentTab(tab) {
            return tab.type === 'imgs'
                ? this.allImgs.length
                : this.source[tab.value].length;
        },
        showPreviewImgPop(index, item) {
            let previewPopIns = popMgr.create(PreviewImagePop);
            previewPopIns.init({
                theme: this.theme,
                isMobileSize: this.isMobileSize,
                sourceList: this.source.imgs,
                index,
                item
            })
        },
        streamToInner(item, index) {
            const { type } = item;
            if (type === 'img') {
                this.showPreviewImgPop(index, item)
            }
        },
        handleShare() {
            this.$emit('share');
        },
        formatUrl(url) {
            const res = this.parseYoutube(url);
            if (res.overwrite) {
                return res.url;
            } else {
                return url;
            }
        },
        parseYoutube(url) {
            /*https://youtu.be/Ounzu9U8NNc
            https://youtu.be/Ounzu9U8NNc?t=19
            https://www.youtube.com/watch?v=Ounzu9U8NNc
             converted to https://www.youtube.com/embed/Ounzu9U8NNc
            */
            let hash;
            try {
                let regs = [
                    /http?s:\/\/youtu.be\/([^?/]*)/,
                    /http?s:\/\/www.youtube.com\/watch\?v=([^?/]*)/
                ];

                let matches = regs.map(reg => url.match(reg));
                matches = matches.filter(match => match?.length === 2);
                hash = matches[0][1] || '';
            } catch (error) {
                console.log(error);
                return { overwrite: false, url };
            }

            if (!hash) {
                return { overwrite: false, url }; 
            }
            return {
                overwrite: true,
                url: `https://www.youtube.com/embed/${hash}`
            };
        },

        canPlayWithVideo(url) {
            return /^.*.mp4|.webm|.ogg$/i.test(url);
        },
        _openGalleryPop(index = 0, $event, item) {
            let virtuals = this.source.virtuals || [];
            let videos = this.source.videos || [];
            let _index = index;
            if (videos.length > 0 && virtuals.length > 0) {
                _index -= 2
            } else if (videos.length > 0 || virtuals.length > 0) {
                _index -= 1
            }
            
            this.currentMediaTabIndex = _index <= 0 ? 0 : _index
            
            setTimeout(() => {
                const galleryPopRef = this.$refs?.galleryPopRef;
                const el = galleryPopRef?.querySelectorAll('.img-box')[_index];
                _index &&
                    el &&
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start'
                    });
            });
        },
        _openVirtualTourPop() {
            this.fingerPs.then(() => {
                this.selectedTab = 'virtuals';
            });
        },
        _openVideoPop() {
            this.fingerPs.then(() => {
                this.selectedTab = 'videos';
            });
        },
        closeInnerPop() {
            this.display(false);
            this.selectedTab = 'imgs';
            this.currentMediaTabIndex = 0;
        },
        removePinchEvent() {
            const Hammer = window?.Hammer;
            Hammer && Hammer.Manager.destroy();
        },
        async handleChangeTabs(item, index) {
            if (index > 0) {
                const url = this.source[item.value][0].url;
                if (url) {
                    const res = await API.getCanXFrame.call(this, url);
                    if (!res?.data?.canXFrame) {
                        window.open(url, '_blank');
                        return;
                    }
                }
            }
            this.selectedTab = item.value;
            this.currentMediaTabIndex = 0;
        },
        handleReduce() {
            let { scaleValue } = this;
            scaleValue = scaleValue < 10 ? 0 : scaleValue - 10;
            this.scaleValue = scaleValue;
        },
        handleRelarge() {
            let { scaleValue } = this;
            scaleValue = scaleValue > 190 ? 200 : scaleValue + 10;
            this.scaleValue = scaleValue;
        },
        formatTooltip(value) {
            return value + '%';
        },
        request() {
            signLog.register(
                {
                    registerTitle: null,
                    submitRegister: ''
                },
                'evaluationRegister'
            );
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.comp-gallery-pop-layout1 {
    margin: 30px;
    width: calc(100vw - 60px);
    height: calc(100vh - 60px);
    background: #fff;
    overflow: hidden;
    .iconfont {
        cursor: pointer;
        &.icon-heart-fill {
            &.active {
                color: #f0454c !important;
            }
        }
    }
    .com-gallery-pop_inner {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        .inner-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            font-size: 12px;
            color: var(--g-primary-color);
            padding: 0 20px;
            height: 70px;
            margin-bottom: 20px;
            
            .inner-tab {
                display: flex;
                height: 100%;
                border-bottom: none;
                gap: 30px;
                p {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 0;
                    opacity: 0.5;
                    &.active {
                        font-family: var(--font-medium);
                        border-bottom: 3px solid var(--g-primary-color);
                        opacity: 1;
                    }
                }
            }
            // .img-number {
            //     font-size: 18px;
            //     > span {
            //         color: var(--mg-button-background);
            //     }
            // }
            .inner-status {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 15px;
                .pop-icons {
                    color: var(--g-primary-color);
                    display: flex;
                    cursor: pointer;
                    margin: 0;
                    &.save {
                        padding: 5px;
                        .iconfont {
                            font-size: 16px;
                            color: var(--g-primary-color);
                            &.icon-favorite_02 {
                                color: #f0454c;
                            }
                        }
                        &:hover {
                            background: rgba(25, 25, 25, 0.05);
                            border-radius: 50%;
                        }
                    }
                    &.share {
                        position: relative;
                        padding: 5px;
                        .iconfont {
                            color: var(--g-primary-color);
                        }
                        &:hover {
                            background: rgba(25, 25, 25, 0.05);
                            border-radius: 50%;
                            .popper {
                                visibility: visible;
                            }
                        }
                        .popper {
                            position: absolute;
                            top: 100%;
                            left: 50%;
                            padding-top: 15px;
                            z-index: var(--level-medium);
                            transform: translateX(-50%);
                            visibility: hidden;
                        }
                    }
                    &.request {
                        font-size: 16px;
                        height: 40px;
                        padding: 0 15px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-family: var(--font-bold);
                        max-width: 250px;
                        @include ellipsis();
                        @include color-button();
                        margin-right: 5px;
                    }
                    &.tour {
                        font-size: 16px;
                        height: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-family: var(--font-bold);
                        padding: 0 15px;
                        @include color-button();
                        margin-right: 5px;
                    }
                }
                .iconfont {
                    font-size: 16px;
                    &.icon-close-light {
                        font-size: 22px;
                    }
                }
            }
        }

        .inner-content {
            flex: 1;
            display: flex;
            padding: 0 20px;
            flex-direction: row;
            justify-content: center;
            background: #fff;
            overflow: hidden;
            .img-tabs {
                width: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                display: grid;
                grid-template-columns: repeat(6, 1fr);
                gap: 2px;
                margin-right: 0;
                padding-right: 0;

                &::-webkit-scrollbar {
                    overflow-y: hidden;
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: rgba(32, 36, 5, 0.2);
                    width: 4px;
                    border-radius: 6px;
                }
                &:hover::-webkit-scrollbar {
                    overflow-y: auto;
                }
                
                .img-box:nth-child(5n + 1), .img-box:nth-child(5n + 2) {
                    grid-column: span 3;
                    height: 400px;
                }
                .img-box:nth-child(5n + 3),
                .img-box:nth-child(5n + 4),
                .img-box:nth-child(5n + 5) {
                    grid-column: span 2;
                    height: 300px;
                }
                > div:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }
    }
    .video-container {
        width: 100%;
        height: 100%;
        .video-content {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
